import { createSelector } from 'reselect';
import { initialState } from './reducer';

/**
 * Direct selector to the uploadMedia state domain
 */

const selectUploadMediaDomain = state => state.uploadMedia || initialState;

/**
 * Other specific selectors
 */

const makeSelectLoading = () =>
  createSelector(
    selectUploadMediaDomain,
    substate => substate.loading,
  );

const makeSelectError = () =>
  createSelector(
    selectUploadMediaDomain,
    substate => substate.error,
  );

const makeSelectUploadedFile = () =>
  createSelector(
    selectUploadMediaDomain,
    substate => substate.uploadedFile,
  );
const makeSelectUploadedFileType = () =>
  createSelector(
    selectUploadMediaDomain,
    substate => substate.uploadedFileType,
  );

/**
 * Default selector used by UploadMedia
 */

const makeSelectUploadMedia = () =>
  createSelector(
    selectUploadMediaDomain,
    substate => substate,
  );

// export default makeSelectUploadMedia;
export {
  makeSelectUploadMedia,
  selectUploadMediaDomain,
  makeSelectError,
  makeSelectLoading,
  makeSelectUploadedFile,
  makeSelectUploadedFileType,
};
